const TEMP_UPLOADS_BASE = `${(process.env.PUBLIC_URL || "").replace(/\/$/, "")}/uploads/temp`;
const API_UPLOADS_BASE = (
  process.env.REACT_APP_ASSETS_BASE_URL || "http://localhost:4000/uploads"
).replace(/\/$/, "");

const API_UPLOAD_PREFIXES = [
  "photos/",
  "homepage-show/",
  "homepage-latest/",
  "stories-assets/",
  "about-selfies/",
  "stories/",
];

/**
 * Resolve a photo key or legacy filename to a public URL.
 * Keys under `homepage-show/` or `photos/` are served from the API upload store.
 * Legacy placeholder filenames still load from `public/uploads/temp/`.
 *
 * @param {string} key
 */
export function uploadUrl(key) {
  if (!key) return "";
  if (/^https?:\/\//.test(key)) return key;

  const normalized = key.replace(/^\//, "");
  const usesApiStore = API_UPLOAD_PREFIXES.some((prefix) => normalized.startsWith(prefix));
  const base = usesApiStore ? API_UPLOADS_BASE : TEMP_UPLOADS_BASE;
  return `${base}/${normalized}`;
}

/**
 * Prefer the API-provided absolute URL; fall back to resolving the storage key.
 *
 * @param {{ imageKey?: string | null, url?: string | null }} photo
 */
export function photoUrl(photo) {
  if (!photo?.imageKey && !photo?.url) return "";
  if (photo.url) return photo.url;
  return uploadUrl(photo.imageKey);
}

/** @param {string} key */
export function assetUrl(key) {
  return uploadUrl(key);
}
